import type { DirectoryUser, OrgUnitDto } from '@halo/shared';

/** Tra cứu danh bạ + phòng/nhóm. Dựng MỘT lần từ dữ liệu bootstrap rồi dùng lại (useMemo). */
export interface Directory {
  users: readonly DirectoryUser[];
  departments: readonly OrgUnitDto[];
  userByUsername: (username: string | null | undefined) => DirectoryUser | undefined;
  /** Tên hiển thị; không có trong danh bạ (ngoài phạm vi / đã xoá) thì trả chính tên đăng nhập. */
  displayName: (username: string | null | undefined) => string;
  unitName: (unitId: string | null | undefined) => string;
  /** Nhóm của một phòng; bỏ trống `departmentId` = mọi nhóm. */
  teamsOf: (departmentId?: string) => OrgUnitDto[];
}

export function buildDirectory(
  users: readonly DirectoryUser[],
  orgUnits: readonly OrgUnitDto[],
): Directory {
  const userMap = new Map(users.map((user) => [user.username, user]));
  const unitMap = new Map(orgUnits.map((unit) => [unit.id, unit]));
  const teams = orgUnits.filter((unit) => unit.kind === 'team');
  return {
    users,
    departments: orgUnits.filter((unit) => unit.kind === 'department'),
    userByUsername: (username) => (username ? userMap.get(username) : undefined),
    displayName: (username) => (username ? (userMap.get(username)?.displayName ?? username) : '—'),
    unitName: (unitId) => (unitId ? (unitMap.get(unitId)?.name ?? unitId) : ''),
    teamsOf: (departmentId) =>
      departmentId ? teams.filter((team) => team.parentId === departmentId) : teams,
  };
}
